import React from "react";
import "./footer.css";
function Footer() {
  return <div className="footer">Thanks for reading to the end ❤️</div>;
}

export default Footer;